import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "research-plans" */ '@/views/research-plans/Index');
let show = () => import(/* webpackChunkName: "research-plans" */ '@/views/research-plans/Show');


export default [
    {
        path: "research-plans",
        name: "research-plans.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['research-plans:viewAny','research-plans:view'],
            title: "طرح پژوهشی"
        }
    },
    {
        path: "research-plans/:mobile",
        name: "research-plans.show",
        component: show,
        meta: {
            middleware: web,
            permissions: ['research-plans:view'],
            title: "طرح پژوهشی"
        }
    }


]